import { forwardRef } from "react";

import { useTheme } from "@mui/material";

import { FormButton, FormButtonProps } from "./FormButton";

import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { mergeSx } from "@/helpers/mergeSx";

export const FormOverlayButton = forwardRef<HTMLButtonElement, FormButtonProps>(({ children, sx, ...props }, ref) => {
  const theme = useTheme();

  if (!theme.palette.forms || !theme.palette.formsComponents?.global || !theme.palette.formsComponents?.overlayButton) {
    return <InvalidThemeErrorMessage />;
  }

  const style = mergeSx(
    {
      padding: 0,
      display: "inline-flex",
      alignItems: "center",
      borderRadius: 1,
      boxShadow: theme.boxShadow.base.light,
      border: theme.palette.formsComponents.overlayButton.border,
      color: theme.palette.formsComponents.overlayButton.labelColor,
      backgroundColor: theme.palette.formsComponents.overlayButton.backgroundColor,
      "&:hover": {
        backgroundColor: `${theme.palette.formsComponents.overlayButton.hoverBackgroundColor} !important`,
      },
      "&:focus": {
        backgroundColor: theme.palette.formsComponents.overlayButton.backgroundColor,
      },
    },
    sx
  );

  return (
    <FormButton {...props} sx={style} ref={ref}>
      {children}
    </FormButton>
  );
});

FormOverlayButton.displayName = "FormOverlayButton";
